var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.OrderShowing && _vm.EmptyOrder)?_c('loading-message',{staticClass:"my-5",attrs:{"message":_vm.$t('views.main.orders.order_closed.loading_order')}}):_c('warehouse-app-order',{attrs:{"order":_vm.Order}})}
var staticRenderFns = []

export { render, staticRenderFns }